module.exports = __webpack_public_path__ + "img/KF.0387209f.png";